
webpack.register(
    'modules/player-list/player-list',
    function() {
        return import('modules/player-list/player-list');
    },
    true
);